import { Hash } from 'lucide-react';

export const GAME_INFO = {
  id: 3,
  title: 'Tres en Ratlla',
  description: '',
  instructions: [
    'Clica a les caselles per col·locar la teva fitxa (X).',
    "L'objectiu és aconseguir tres fitxes en línia (horitzontal, vertical o diagonal).",
    'Guanya partides per completar la ronda i avançar.',
    "Si l'IA guanya, perds el joc. Compte amb la dificultat!",
  ],
  icon: Hash,
  path: '/tres-en-ratlla',
  category: 'Estratègia',
  localStorageKey: 'ticTacToeGameStats',
  customStatLabel: 'Partides Guanyades',
  customStatLabelSingular: 'Partida Guanyada',
  defaultGameMode: 'facil',
  gameModeTitle: 'Selecciona la Dificultat',
  gameModes: [
    {
      id: 'facil',
      name: 'Fàcil',
    },
    {
      id: 'normal',
      name: 'Normal',
    },
    {
      id: 'dificil',
      name: 'Difícil',
    },
  ],
};
